import { render, staticRenderFns } from "./investor-research.vue?vue&type=template&id=1bcba326&"
import script from "./investor-research.vue?vue&type=script&lang=js&"
export * from "./investor-research.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcba326')) {
      api.createRecord('1bcba326', component.options)
    } else {
      api.reload('1bcba326', component.options)
    }
    module.hot.accept("./investor-research.vue?vue&type=template&id=1bcba326&", function () {
      api.rerender('1bcba326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/investor-research.vue"
export default component.exports